import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';

export const useFetchCategories = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [ dataCategories, setDataCategories ] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllCategories, setLoadingFetchAllCategories ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/cashier-managements/categories`)
            // console.log('[useFetch][useFetchCategories] response.data :::', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllCategories(true)
        fetchData()
            .then((resp) => {
                setDataCategories(resp.rows)
                setLoadingFetchAllCategories(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllCategories(false)
            })
    }, [execute])

    return {  dataCategories, loadingFetchAllCategories , executeFetch }

}

export const useFetchManagements = ({marvarApi, dispatch, onLogout, user}) => {

    // 1. Para los datos recuperados de la BD
    const [ dataManagements, setDataManagements ] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllManagements, setLoadingFetchAllManagements ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/cashier-managements/managements-by-user/${user.uid}`)
            // console.log('[useFetchData][useFetchManagements] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllManagements(true)
        fetchData()
            .then((resp) => {
                setDataManagements(resp.rows)
                setLoadingFetchAllManagements(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllManagements(false)
            })
    }, [execute])

    return {  dataManagements, loadingFetchAllManagements, executeFetch }

}

export const useFetchSpecificExpense = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormScreen } = Forms
    const { formState, setFormState } = FormScreen
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificHouse, setLoadingFetchSpecificHouse ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idexpense: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/cashier-managements/fetch-specific-expense/${paramsToSearch.idexpense}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idexpense > 0 ){
            setLoadingFetchSpecificHouse(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idexpense: rows[0].idexpense || '',
                        descripcion: rows[0].descripcion || ''
                    }))
                    setLoadingFetchSpecificHouse(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificHouse(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificHouse, setParamsToSearch, executeFetch }

}

export const useFetchPdfAdminToCentral = ({ marvarApi, dispatch, onLogout }) => {

    const _defaultParams = {
        idgestion: '',
    }
    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)

    const [ dataPdfAdminToCentral, setDataPdfAdminToCentral ] = useState('')

    const [ loadingFetchPdfAdminToCentral, setLoadingFetchPdfAdminToCentral ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataPdfAdminToCentral('')
        setParamsToSearch(_defaultParams)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const idgestion = parseInt(paramsToSearch.idgestion, 10)
            const response = await marvarApi.get(`/cashier-managements/pdf/admin-to-central/${idgestion}`, {
                responseType: 'blob'
            })
            console.log('[useFetchData][useFetchPdfAdminToCentral] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (
            paramsToSearch.idgestion > 0
            && paramsToSearch.idgestion !== ''
        ) {
            setDataPdfAdminToCentral('')
            setLoadingFetchPdfAdminToCentral(true)
            fetchData()
                .then(async (resp) => {
                    if (resp?.type.includes('application/pdf')) {
                        setDataPdfAdminToCentral(URL.createObjectURL(resp))
                    } else if (resp?.type.includes('application/json')) {
                        const data = JSON.parse(await resp.text())
                        setDataPdfAdminToCentral(data)
                    }
                    setLoadingFetchPdfAdminToCentral(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setDataPdfAdminToCentral('')
                    setLoadingFetchPdfAdminToCentral(false)
                })
        }
    }, [execute])

    useEffect(() => {
        return () => {
            if (typeof dataPdfAdminToCentral === 'string' && dataPdfAdminToCentral) {
                URL.revokeObjectURL(dataPdfAdminToCentral)
            }
        }
    }, [dataPdfAdminToCentral])

    return { dataPdfAdminToCentral, loadingFetchPdfAdminToCentral, setParamsToSearch, executeFetch, resetFetch }
}
